import { tasksText } from './getCalendarListContextMenuItems.locstring.json';
import type { IContextualMenuItem } from '@fluentui/react/lib/ContextualMenu';
import CheckmarkFilled from 'owa-fluent-icons-svg/lib/icons/CheckmarkFilled';
import CircleRegular from 'owa-fluent-icons-svg/lib/icons/CircleRegular';
import loc from 'owa-localize';
import { isTaskListSelected, updateIsTaskListSelected } from 'owa-calendar-list-settings';
import { getPalette } from 'owa-theme';

import styles from './CalendarPickerItems.scss';

export function getTaskMenuItem(): IContextualMenuItem {
    const isSelected = isTaskListSelected();
    const palette = getPalette();
    return {
        key: 'calendar_list_tasks_item_key',
        text: loc(tasksText),
        title: loc(tasksText),
        checked: isSelected,
        onClick: (event: React.MouseEvent<HTMLElement>) => {
            event.preventDefault();
            updateIsTaskListSelected(!isSelected);
        },
        role: 'menuitemcheckbox',
        itemProps: {
            styles: {
                label: styles.calendarPickerCalendarLabel,
            },
        },
        iconProps: {
            iconName: isSelected ? CheckmarkFilled : CircleRegular,
            className: isSelected ? styles.calendarIconCheckMark : styles.calendarIconLoaded,
            style: isSelected
                ? {
                      backgroundColor: palette.themePrimary,
                      color: palette.white,
                  }
                : {
                      color: palette.themePrimary,
                      background: 'transparent',
                  },
        },
    };
}
